// @ts-nocheck
/* eslint-disable */
'use strict';

import _ from 'lodash';
import { PickLists } from './PickListParser';
import { EventDispatcher } from 'strongly-typed-events/dist/';
import { FieldChangedEventArgs } from './FieldChangeEventArgs';

export class FieldParser {
    private FieldCollection: Map<string, string> = new Map();
    private FieldDateFormats: Map<string, string> = new Map();
    private Properties: string[];
    private static AutoCorrectFields: string[] = ['HS_PRIOR1', 'HS_PRIOR2', 'ST_SITSIZE', 'FN_CONC1', 'DA_CONSTQL', 'AG_COND1', 'DP_OVRLCOND', 'PR_SALEPR1', 'SF_GLA'];
    private parserExecuting = false;
    private static FieldRelationships: Map<string, string[]> = new Map();
    public ParserActive: boolean = true;
    public OnFieldValueChanged = new EventDispatcher<FieldParser, FieldChangedEventArgs>();

    public constructor() {
        PickLists.InitPickLists();
        this.InitFieldRelationships();
        this.InitFieldDateFormats();
        this.Properties = Object.getOwnPropertyNames(this);
    }

    private InitFieldDateFormats() {
        this.FieldDateFormats.set('HS_PRIOR1', 'MMDDYYYY');
        this.FieldDateFormats.set('EX_CONTDATE', 'MMYY');
        this.FieldDateFormats.set('EX_SETTDATE', 'MMYY');
        this.FieldDateFormats.set('EX_WTDRDATE', 'MMYY');
        this.FieldDateFormats.set('EX_EXPRDATE', 'MMYY');
    }

    private InitFieldRelationships() {
        // <Parent/Trigger Field, Child/DFE Fields>
        FieldParser.FieldRelationships.set('AD_ADDR2', ['DB_UNITNO', 'DB_CITY', 'DB_STATE', 'DB_ZIPCODE']);
        FieldParser.FieldRelationships.set('SC_SOURCE1', ['EX_DATASRC1', 'EX_DOM']);
        FieldParser.FieldRelationships.set('FN_CONC2', ['DP_FINTYP1', 'EX_OTHCONC', 'EX_CONCAMT', 'FU_FUNCTUT']);
        FieldParser.FieldRelationships.set('DT_SALTIM1', ['DP_CMPTYPE', 'EX_CONTKWN', 'EX_CONTUNK', 'EX_CONTDATE', 'EX_SETTDATE', 'EX_WTDRDATE', 'EX_EXPRDATE']);
        FieldParser.FieldRelationships.set('LC_LOCAT1', ['DP_LOCAT', 'DP_LOC1', 'EX_LOC1OTH', 'DP_LOC2', 'EX_LOC2OTH']);
        FieldParser.FieldRelationships.set('ST_SITEVW', ['DP_SITVW1', 'DP_SITVW2', 'EX_SITVWO2', 'DP_SITVW3', 'EX_SITVWO3']);
        FieldParser.FieldRelationships.set('DA_DESAPL1', ['TP_DETACH', 'TP_ATTACHED', 'TP_SEMIDET', 'NUMSTORIES', 'AB_DESAPL1', 'EX_DESAPL1', 'NUMLEVELS', 'PT_DETACH', 'PT_GARDEN', 'PT_HIRISE', 'PT_MIDRISE', 'PT_ROWTOWN', 'PT_OTHER']);
        FieldParser.FieldRelationships.set('BM_BSM1', ['EX_BSMSF', 'EX_BSMFIN', 'DP_BSMEXIT']);
        FieldParser.FieldRelationships.set('BM_BSM2', ['EX_BSMRECRM', 'EX_BSMBED', 'EX_BSMBATH', 'EX_BSMFBATH', 'EX_BSMHBATH', 'EX_BSMOTHRM']);
        FieldParser.FieldRelationships.set('HC_HTCOOL', ['DB_HEAT', 'DB_COOL']);
        FieldParser.FieldRelationships.set('CR_GARPRK1', ['EX_CARNONE', 'EX_GARATT', 'EX_GARDET', 'EX_GARBLT', 'EX_CARPT', 'EX_DRVWY', 'EX_DWSURF', 'EX_GARPRK', 'EX_COVPRK', 'EX_OPENPRK', 'AB_GARPRK']);
        FieldParser.FieldRelationships.set('RM_BATH', ['RM_FBATH', 'RM_HBATH']);
        FieldParser.FieldRelationships.set('PF_PORPAT1', ['DB_PORCH', 'DB_PATIO', 'DB_DECK']);
    }

    private _AD_ADDR1: string = '';
    private _AD_ADDR2: string = '';
    private _DB_UNITNO: string = '';
    private _DB_CITY: string = '';
    private _DB_STATE: string = '';
    private _DB_ZIPCODE: string = '';
    private _PR_SALEPR1: string = '';
    private _PU_PERGLA: string = '';
    private _SC_SOURCE1: string = '';
    private _EX_DATSRC1: string = '';
    private _EX_DOM: string = '';
    private _SC_SOURCE2: string = '';
    private _FN_CONC1: string = '';
    private _FN_CONC2: string = '';
    private _DP_FINTYP1: string = '';
    private _EX_OTHCONC: string = '';
    private _EX_CONCAMT: string = '';
    private _FU_FUNCTUT: string = '';
    private _DT_SALTIM1: string = '';
    private _DP_CMPTYPE: string = '';
    private _EX_CONTKWN: boolean = false;
    private _EX_CONTUNK: boolean = false;
    private _EX_CONTDATE: string = '';
    private _EX_SETTDATE: string = '';
    private _EX_WTDRDATE: string = '';
    private _EX_EXPRDATE: string = '';
    private _LC_LOCAT1: string = '';
    private _DP_LOCAT: string = '';
    private _DP_LOC1: string = '';
    private _EX_LOC1OTH: string = '';
    private _DP_LOC2: string = '';
    private _EX_LOC2OTH: string = '';
    private _RG_RIGHTS: string = '';
    private _ST_SITSIZE: string = '';
    private _ST_SITEVW: string = '';
    private _DP_SITVW1: string = '';
    private _DP_SITVW2: string = '';
    private _EX_SITVWO2: string = '';
    private _DP_SITVW3: string = '';
    private _EX_SITVWO3: string = '';
    private _DA_DESAPL1: string = '';
    private _TP_DETACH: boolean = false;
    private _TP_ATTACH: boolean = false;
    private _TP_SEMIDET: boolean = false;
    private _NUMSTORIES: string = '';
    private _EX_DESAPL1: string = ''; //this is the page 1 value shown in the subject DFE
    private _PT_DETACH: boolean = false;
    private _PT_ROWTOWN: boolean = false;
    private _PT_GARDEN: boolean = false;
    private _PT_MIDRISE: boolean = false;
    private _PT_HIRISE: boolean = false;
    private _PT_OTHER: boolean = false;
    private _NUMLEVELS: string = '';
    private _AB_DESAPL1: string = '';
    private _DA_CONSTQL: string = '';
    private _AG_AGYRBLT: string = '';
    private _DB_ACTAGE: string = '';
    private _DB_EFFAGE: string = '';
    private _AG_COND1: string = '';
    private _RM_TOTAL: string = '';
    private _RM_BED: string = '';
    private _RM_BATH: string = '';
    private _RM_HBATH: string = '';
    private _RM_FBATH: string = '';
    private _SF_GLA: string = '';
    private _BM_BSM1: string = '';
    private _EX_BSMSF: string = '';
    private _EX_BSMFIN: string = '';
    private _DP_BSMEXIT: string = '';
    private _BM_BSM2: string = '';
    private _EX_BSMRECRM: string = '';
    private _EX_BSMBED: string = '';
    private _EX_BSMBATH: string = '';
    private _EX_BSMFBATH: string = '';
    private _EX_BSMHBATH: string = '';
    private _EX_BSMOTHRM: string = '';
    private _HC_HTCOOL: string = '';
    private _DB_HEAT: string = '';
    private _DB_COOL: string = '';
    private _EE_EFFIC1: string = '';
    private _CR_GARPRK1: string = '';
    private _EX_CARNONE: boolean = false;
    private _EX_GARATT: string = '';
    private _EX_GARDET: string = '';
    private _EX_GARBLT: string = '';
    private _EX_CARPT: string = '';
    private _EX_DRVWY: string = '';
    private _EX_DWSURF: string = '';
    private _EX_GARPRK: string = '';
    private _EX_COVPRK: string = '';
    private _EX_OPENPRK: string = '';
    private _AB_GARPRK: string = '';
    private _PF_PORPAT1: string = '';
    private _DB_PORCH: string = '';
    private _DB_PATIO: string = '';
    private _DB_DECK: string = '';
    private _BL_BLANK1: string = '';
    private _BL_BLANK2: string = '';
    private _BL_BLANK3: string = '';
    private _HS_PRIOR1: string = '';
    private _HS_PRIOR2: string = '';
    private _HS_PRIOR3: string = '';
    private _HS_DSDATE: string = '';
    private _AD_PROJECT: string = '';
    private _PJ_PHASE: string = '';
    private _FE_MAINT: string = '';
    private _RC_FACIL1: string = '';
    private _RC_FACIL2: string = '';
    private _FL_LOC: string = '';

    private ParserIsActive(): boolean {
        return this.ParserActive && !this.parserExecuting;
    }

    private ContainsField(field: string) {
        let propName: string = '_' + field;
        return this.Properties.includes(propName);
    }

    public SetFieldText(field: string, value: string) {
        try {
            if (this.ContainsField(field)) {
                let propName: string = '_' + field;
                var descriptor = Object.getOwnPropertyDescriptor(this, propName);

                if (_.isString(descriptor.value)) {
                    Reflect.set(this, field, value);
                } else if (_.isBoolean(descriptor.value)) {
                    let boolVal: boolean = false;
                    if (value.length > 0 && value.toLowerCase() != 'false') {
                        // Any value other than "false" is considered true.
                        boolVal = true;
                    }
                    Reflect.set(this, field, boolVal);
                }
            }
        } catch (error) {
            console.log(`FieldParser.SetFieldText(), Error[${error}]`);
        }
    }

    private InternalSetFieldText(field: string, value: string) {
        try {
            if (this.ContainsField(field)) {
                let oldValue: string = this.FieldCollection.get(field);
                if (oldValue == undefined) oldValue = '';
                let valueChanged: boolean = !(oldValue == value);
                this.FieldCollection.set(field, value);

                if (FieldParser.AutoCorrectFields.includes(field)) {
                    this.AutoCorrectUADValue(field);
                }

                if (this.ParserIsActive()) {
                    this.Parse(field);
                }

                if (this.parserExecuting && valueChanged) this.OnFieldValueChanged.dispatch(this, new FieldChangedEventArgs(field, value));
            }
        } catch (error) {
            console.log(`FieldParser.InternalSetFieldText(), f: ${field} v:${value} err: ${error}`);
        }
    }

    /*
     * After setting all child fields, call this method to build the concatenated value for all trigger fields.
     */
    public BuildTriggerFields() {
        this.ParserActive = true;
        FieldParser.FieldRelationships.forEach((values: string[], key: string, map: Map<string, string[]>) => {
            try {
                for (let value of values) {
                    this.Parse(value);
                }
            } catch (error) {
                console.log(`FieldParser.BuildTriggerFields(), Error[${error}]`);
            }
        });
    }

    /*
     * Build a single trigger field.
     */
    public BuildTriggerField(triggerFieldName: string) {
        this.ParserActive = true;
        try {
            let values: string[] = FieldParser.FieldRelationships.get(triggerFieldName);
            // If values is undefined that means we didn't get a trigger field.
            if (values == undefined) {
                // Check to see if a child field was passed in.
                values = this.GetChildFields(triggerFieldName);
                if (values == undefined) return;
            }
            for (let value of values) {
                this.Parse(value);
            }
        } catch (error) {
            console.log(`FieldParser.BuildTriggerField(), Error[${error}]`);
        }
    }

    private GetChildFields(fieldName: string): string[] {
        let fields: string[];
        FieldParser.FieldRelationships.forEach((values: string[], key: string, map: Map<string, string[]>) => {
            try {
                for (let value of values) {
                    if (values.includes(fieldName)) {
                        fields = values;
                        break;
                    }
                }
            } catch (error) {
                console.log(`FieldParser.GetChildFields(), Error[${error}]`);
            }
        });
        return fields;
    }

    /*
     * After setting the concatenated value for each trigger field, call this method to parse each
     * trigger fields and populate the DFE/child fields.
     */
    public ParseTriggerFields() {
        this.ParserActive = true;
        FieldParser.FieldRelationships.forEach((values: string[], key: string, map: Map<string, string[]>) => {
            try {
                this.Parse(key);
            } catch (error) {
                console.log(`FieldParser.ParseTriggerFields(), Error[${error}]`);
            }
        });
    }

    public isParentField(triggerFieldName: string): boolean {
        let BreakException = {};
        let result = false;
        FieldParser.FieldRelationships.forEach((values: string[], key: string, map: Map<string, string[]>) => {
            try {
                if (triggerFieldName.toLowerCase() === key.toLowerCase()) {
                    throw BreakException;
                }
            } catch (error) {
                if (error !== BreakException) throw error;
                result = true;
            }
        });

        return result;
    }

    /*
     * Parse a single trigger field.
     */
    public ParseTriggerField(triggerFieldName: string) {
        this.ParserActive = true;
        this.Parse(triggerFieldName);
    }

    public GetFieldText(field: string): string {
        let result: string = '';

        try {
            if (this.ContainsField(field)) {
                if (this.FieldCollection.has(field)) {
                    // Field already exists so update existing value.
                    result = this.FieldCollection.get(field);
                }
            }
        } catch (error) {
            console.log(`FieldParser.GetFieldText(), Error[${error}]`);
        }

        return result;
    }

    get AD_ADDR1(): string {
        return this._AD_ADDR1;
    }
    set AD_ADDR1(value: string) {
        this._AD_ADDR1 = value;
        this.InternalSetFieldText('AD_ADDR1', value);
    }

    get AD_ADDR2(): string {
        return this._AD_ADDR2;
    }
    set AD_ADDR2(value: string) {
        this._AD_ADDR2 = value;
        this.InternalSetFieldText('AD_ADDR2', value);
    }

    get DB_UNITNO(): string {
        return this._DB_UNITNO;
    }
    set DB_UNITNO(value: string) {
        this._DB_UNITNO = value;
        this.InternalSetFieldText('DB_UNITNO', value);
    }

    get DB_CITY(): string {
        return this._DB_CITY;
    }
    set DB_CITY(value: string) {
        this._DB_CITY = value;
        this.InternalSetFieldText('DB_CITY', value);
    }

    get DB_STATE(): string {
        return this._DB_STATE;
    }
    set DB_STATE(value: string) {
        this._DB_STATE = value;
        this.InternalSetFieldText('DB_STATE', value);
    }

    get DB_ZIPCODE(): string {
        return this._DB_ZIPCODE;
    }
    set DB_ZIPCODE(value: string) {
        this._DB_ZIPCODE = value;
        this.InternalSetFieldText('DB_ZIPCODE', value);
    }

    get PR_SALEPR1(): string {
        return this._PR_SALEPR1;
    }
    set PR_SALEPR1(value: string) {
        this._PR_SALEPR1 = value;
        this.InternalSetFieldText('PR_SALEPR1', value);
    }

    get PU_PERGLA(): string {
        return this._PU_PERGLA;
    }
    set PU_PERGLA(value: string) {
        this._PU_PERGLA = value;
        this.InternalSetFieldText('PU_PERGLA', value);
    }

    get SC_SOURCE1(): string {
        return this._SC_SOURCE1;
    }
    set SC_SOURCE1(value: string) {
        this._SC_SOURCE1 = value;
        this.InternalSetFieldText('SC_SOURCE1', value);
    }

    get EX_DATSRC1(): string {
        return this._EX_DATSRC1;
    }
    set EX_DATSRC1(value: string) {
        this._EX_DATSRC1 = value;
        this.InternalSetFieldText('EX_DATSRC1', value);
    }

    get EX_DOM(): string {
        return this._EX_DOM;
    }
    set EX_DOM(value: string) {
        this._EX_DOM = value;
        this.InternalSetFieldText('EX_DOM', value);
    }

    get SC_SOURCE2(): string {
        return this._SC_SOURCE2;
    }
    set SC_SOURCE2(value: string) {
        this._SC_SOURCE2 = value;
        this.InternalSetFieldText('SC_SOURCE2', value);
    }

    get FN_CONC1(): string {
        return this._FN_CONC1;
    }
    set FN_CONC1(value: string) {
        this._FN_CONC1 = value;
        this.InternalSetFieldText('FN_CONC1', value);
    }

    get FN_CONC2(): string {
        return this._FN_CONC2;
    }
    set FN_CONC2(value: string) {
        this._FN_CONC2 = value;
        this.InternalSetFieldText('FN_CONC2', value);
    }

    get DP_FINTYP1(): string {
        return this._DP_FINTYP1;
    }
    set DP_FINTYP1(value: string) {
        this._DP_FINTYP1 = value;
        this.InternalSetFieldText('DP_FINTYP1', value);
    }

    get EX_OTHCONC(): string {
        return this._EX_OTHCONC;
    }
    set EX_OTHCONC(value: string) {
        this._EX_OTHCONC = value;
        this.InternalSetFieldText('EX_OTHCONC', value);
    }

    get EX_CONCAMT(): string {
        return this._EX_CONCAMT;
    }
    set EX_CONCAMT(value: string) {
        this._EX_CONCAMT = value;
        this.InternalSetFieldText('EX_CONCAMT', value);
    }

    get FU_FUNCTUT(): string {
        return this._FU_FUNCTUT;
    }
    set FU_FUNCTUT(value: string) {
        this._FU_FUNCTUT = value;
        this.InternalSetFieldText('FU_FUNCTUT', value);
    }

    get DT_SALTIM1(): string {
        return this._DT_SALTIM1;
    }
    set DT_SALTIM1(value: string) {
        this._DT_SALTIM1 = value;
        this.InternalSetFieldText('DT_SALTIM1', value);
    }

    get DP_CMPTYPE(): string {
        return this._DP_CMPTYPE;
    }
    set DP_CMPTYPE(value: string) {
        this._DP_CMPTYPE = value;
        this.InternalSetFieldText('DP_CMPTYPE', value);
    }

    get EX_CONTKWN(): boolean {
        return this._EX_CONTKWN;
    }
    set EX_CONTKWN(value: boolean) {
        this._EX_CONTKWN = value;
        this.InternalSetFieldText('EX_CONTKWN', value == true ? 'X' : '');
    }

    get EX_CONTUNK(): boolean {
        return this._EX_CONTUNK;
    }
    set EX_CONTUNK(value: boolean) {
        this._EX_CONTUNK = value;
        this.InternalSetFieldText('EX_CONTUNK', value == true ? 'X' : '');
    }

    get EX_CONTDATE(): string {
        return this._EX_CONTDATE;
    }
    set EX_CONTDATE(value: string) {
        this._EX_CONTDATE = value;
        this.InternalSetFieldText('EX_CONTDATE', value);
    }

    get EX_SETTDATE(): string {
        return this._EX_SETTDATE;
    }
    set EX_SETTDATE(value: string) {
        this._EX_SETTDATE = value;
        this.InternalSetFieldText('EX_SETTDATE', value);
    }

    get EX_WTDRDATE(): string {
        return this._EX_WTDRDATE;
    }
    set EX_WTDRDATE(value: string) {
        this._EX_WTDRDATE = value;
        this.InternalSetFieldText('EX_WTDRDATE', value);
    }

    get EX_EXPRDATE(): string {
        return this._EX_EXPRDATE;
    }
    set EX_EXPRDATE(value: string) {
        this._EX_EXPRDATE = value;
        this.InternalSetFieldText('EX_EXPRDATE', value);
    }

    get LC_LOCAT1(): string {
        return this._LC_LOCAT1;
    }
    set LC_LOCAT1(value: string) {
        this._LC_LOCAT1 = value;
        this.InternalSetFieldText('LC_LOCAT1', value);
    }

    get DP_LOCAT(): string {
        return this._DP_LOCAT;
    }
    set DP_LOCAT(value: string) {
        this._DP_LOCAT = value;
        this.InternalSetFieldText('DP_LOCAT', value);
    }

    get DP_LOC1(): string {
        return this._DP_LOC1;
    }
    set DP_LOC1(value: string) {
        this._DP_LOC1 = value;
        this.InternalSetFieldText('DP_LOC1', value);
    }

    get EX_LOC1OTH(): string {
        return this._EX_LOC1OTH;
    }
    set EX_LOC1OTH(value: string) {
        this._EX_LOC1OTH = value;
        this.InternalSetFieldText('EX_LOC1OTH', value);
    }

    get DP_LOC2(): string {
        return this._DP_LOC2;
    }
    set DP_LOC2(value: string) {
        this._DP_LOC2 = value;
        this.InternalSetFieldText('DP_LOC2', value);
    }

    get EX_LOC2OTH(): string {
        return this._EX_LOC2OTH;
    }
    set EX_LOC2OTH(value: string) {
        this._EX_LOC2OTH = value;
        this.InternalSetFieldText('EX_LOC2OTH', value);
    }

    get RG_RIGHTS(): string {
        return this._RG_RIGHTS;
    }
    set RG_RIGHTS(value: string) {
        this._RG_RIGHTS = value;
        this.InternalSetFieldText('RG_RIGHTS', value);
    }

    get ST_SITSIZE(): string {
        return this._ST_SITSIZE;
    }
    set ST_SITSIZE(value: string) {
        this._ST_SITSIZE = value;
        this.InternalSetFieldText('ST_SITSIZE', value);
    }

    get ST_SITEVW(): string {
        return this._ST_SITEVW;
    }
    set ST_SITEVW(value: string) {
        this._ST_SITEVW = value;
        this.InternalSetFieldText('ST_SITEVW', value);
    }

    get DP_SITVW1(): string {
        return this._DP_SITVW1;
    }
    set DP_SITVW1(value: string) {
        this._DP_SITVW1 = value;
        this.InternalSetFieldText('DP_SITVW1', value);
    }

    get DP_SITVW2(): string {
        return this._DP_SITVW2;
    }
    set DP_SITVW2(value: string) {
        this._DP_SITVW2 = value;
        this.InternalSetFieldText('DP_SITVW2', value);
    }

    get EX_SITVWO2(): string {
        return this._EX_SITVWO2;
    }
    set EX_SITVWO2(value: string) {
        this._EX_SITVWO2 = value;
        this.InternalSetFieldText('EX_SITVWO2', value);
    }

    get DP_SITVW3(): string {
        return this._DP_SITVW3;
    }
    set DP_SITVW3(value: string) {
        this._DP_SITVW3 = value;
        this.InternalSetFieldText('DP_SITVW3', value);
    }

    get EX_SITVWO3(): string {
        return this._EX_SITVWO3;
    }
    set EX_SITVWO3(value: string) {
        this._EX_SITVWO3 = value;
        this.InternalSetFieldText('EX_SITVWO3', value);
    }

    get DA_DESAPL1(): string {
        return this._DA_DESAPL1;
    }
    set DA_DESAPL1(value: string) {
        this._DA_DESAPL1 = value;
        this.InternalSetFieldText('DA_DESAPL1', value);
    }

    get TP_DETACH(): boolean {
        return this._TP_DETACH;
    }
    set TP_DETACH(value: boolean) {
        this._TP_DETACH = value;
        this.InternalSetFieldText('TP_DETACH', value == true ? 'X' : '');
    }

    get TP_ATTACH(): boolean {
        return this._TP_ATTACH;
    }
    set TP_ATTACH(value: boolean) {
        this._TP_ATTACH = value;
        this.InternalSetFieldText('TP_ATTACH', value == true ? 'X' : '');
    }

    get TP_SEMIDET(): boolean {
        return this._TP_SEMIDET;
    }
    set TP_SEMIDET(value: boolean) {
        this._TP_SEMIDET = value;
        this.InternalSetFieldText('TP_SEMIDET', value == true ? 'X' : '');
    }

    get NUMSTORIES(): string {
        return this._NUMSTORIES;
    }
    set NUMSTORIES(value: string) {
        this._NUMSTORIES = value;
        this.InternalSetFieldText('NUMSTORIES', value);
    }

    get AB_DESAPL1(): string {
        return this._AB_DESAPL1;
    }
    set AB_DESAPL1(value: string) {
        this._AB_DESAPL1 = value;
        this.InternalSetFieldText('AB_DESAPL1', value);
    }

    get EX_DESAPL1(): string {
        return this._EX_DESAPL1;
    }
    set EX_DESAPL1(value: string) {
        this._EX_DESAPL1 = value;
        this.InternalSetFieldText('EX_DESAPL1', value);
    }

    get PT_DETACH(): boolean {
        return this._PT_DETACH;
    }
    set PT_DETACH(value: boolean) {
        this._PT_DETACH = value;
        this.InternalSetFieldText('PT_DETACH', value == true ? 'X' : '');
    }

    get PT_ROWTOWN(): boolean {
        return this._PT_ROWTOWN;
    }
    set PT_ROWTOWN(value: boolean) {
        this._PT_ROWTOWN = value;
        this.InternalSetFieldText('PT_ROWTOWN', value == true ? 'X' : '');
    }

    get PT_GARDEN(): boolean {
        return this._PT_GARDEN;
    }
    set PT_GARDEN(value: boolean) {
        this._PT_GARDEN = value;
        this.InternalSetFieldText('PT_GARDEN', value == true ? 'X' : '');
    }

    get PT_MIDRISE(): boolean {
        return this._PT_MIDRISE;
    }
    set PT_MIDRISE(value: boolean) {
        this._PT_MIDRISE = value;
        this.InternalSetFieldText('PT_MIDRISE', value == true ? 'X' : '');
    }

    get PT_HIRISE(): boolean {
        return this._PT_HIRISE;
    }
    set PT_HIRISE(value: boolean) {
        this._PT_HIRISE = value;
        this.InternalSetFieldText('PT_HIRISE', value == true ? 'X' : '');
    }

    get PT_OTHER(): boolean {
        return this._PT_OTHER;
    }
    set PT_OTHER(value: boolean) {
        this._PT_OTHER = value;
        this.InternalSetFieldText('PT_OTHER', value == true ? 'X' : '');
    }

    get NUMLEVELS(): string {
        return this._NUMLEVELS;
    }
    set NUMLEVELS(value: string) {
        this._NUMLEVELS = value;
        this.InternalSetFieldText('NUMLEVELS', value);
    }

    get DA_CONSTQL(): string {
        return this._DA_CONSTQL;
    }
    set DA_CONSTQL(value: string) {
        this._DA_CONSTQL = value;
        this.InternalSetFieldText('DA_CONSTQL', value);
    }

    get AG_AGYRBLT(): string {
        return this._AG_AGYRBLT;
    }
    set AG_AGYRBLT(value: string) {
        this._AG_AGYRBLT = value;
        this.InternalSetFieldText('AG_AGYRBLT', value);
    }

    get DB_ACTAGE(): string {
        return this._DB_ACTAGE;
    }
    set DB_ACTAGE(value: string) {
        this._DB_ACTAGE = value;
        this.InternalSetFieldText('DB_ACTAGE', value);
    }

    get DB_EFFAGE(): string {
        return this._DB_EFFAGE;
    }
    set DB_EFFAGE(value: string) {
        this._DB_EFFAGE = value;
        this.InternalSetFieldText('DB_EFFAGE', value);
    }

    get AG_COND1(): string {
        return this._AG_COND1;
    }
    set AG_COND1(value: string) {
        this._AG_COND1 = value;
        this.InternalSetFieldText('AG_COND1', value);
    }

    get RM_TOTAL(): string {
        return this._RM_TOTAL;
    }
    set RM_TOTAL(value: string) {
        this._RM_TOTAL = value;
        this.InternalSetFieldText('RM_TOTAL', value);
    }

    get RM_BED(): string {
        return this._RM_BED;
    }
    set RM_BED(value: string) {
        this._RM_BED = value;
        this.InternalSetFieldText('RM_BED', value);
    }

    get RM_BATH(): string {
        return this._RM_BATH;
    }
    set RM_BATH(value: string) {
        this._RM_BATH = value;
        this.InternalSetFieldText('RM_BATH', value);
    }

    get RM_HBATH(): string {
        return this._RM_HBATH;
    }
    set RM_HBATH(value: string) {
        this._RM_HBATH = value;
        this.InternalSetFieldText('RM_HBATH', value);
    }

    get RM_FBATH(): string {
        return this._RM_FBATH;
    }
    set RM_FBATH(value: string) {
        this._RM_FBATH = value;
        this.InternalSetFieldText('RM_FBATH', value);
    }

    get SF_GLA(): string {
        return this._SF_GLA;
    }
    set SF_GLA(value: string) {
        this._SF_GLA = value;
        this.InternalSetFieldText('SF_GLA', value);
    }

    get BM_BSM1(): string {
        return this._BM_BSM1;
    }
    set BM_BSM1(value: string) {
        this._BM_BSM1 = value;
        this.InternalSetFieldText('BM_BSM1', value);
    }

    get EX_BSMSF(): string {
        return this._EX_BSMSF;
    }
    set EX_BSMSF(value: string) {
        this._EX_BSMSF = value;
        this.InternalSetFieldText('EX_BSMSF', value);
    }

    get EX_BSMFIN(): string {
        return this._EX_BSMFIN;
    }
    set EX_BSMFIN(value: string) {
        this._EX_BSMFIN = value;
        this.InternalSetFieldText('EX_BSMFIN', value);
    }

    get DP_BSMEXIT(): string {
        return this._DP_BSMEXIT;
    }
    set DP_BSMEXIT(value: string) {
        this._DP_BSMEXIT = value;
        this.InternalSetFieldText('DP_BSMEXIT', value);
    }

    get BM_BSM2(): string {
        return this._BM_BSM2;
    }
    set BM_BSM2(value: string) {
        this._BM_BSM2 = value;
        this.InternalSetFieldText('BM_BSM2', value);
    }

    get EX_BSMRECRM(): string {
        return this._EX_BSMRECRM;
    }
    set EX_BSMRECRM(value: string) {
        this._EX_BSMRECRM = value;
        this.InternalSetFieldText('EX_BSMRECRM', value);
    }

    get EX_BSMBED(): string {
        return this._EX_BSMBED;
    }
    set EX_BSMBED(value: string) {
        this._EX_BSMBED = value;
        this.InternalSetFieldText('EX_BSMBED', value);
    }

    get EX_BSMBATH(): string {
        return this._EX_BSMBATH;
    }
    set EX_BSMBATH(value: string) {
        if (value == '0') {
            value = '0.0';
        }
        this._EX_BSMBATH = value;
        this.InternalSetFieldText('EX_BSMBATH', value);
    }

    get EX_BSMFBATH(): string {
        return this._EX_BSMFBATH;
    }
    set EX_BSMFBATH(value: string) {
        this._EX_BSMFBATH = value;
        this.InternalSetFieldText('EX_BSMFBATH', value);
    }

    get EX_BSMHBATH(): string {
        return this._EX_BSMHBATH;
    }
    set EX_BSMHBATH(value: string) {
        this._EX_BSMHBATH = value;
        this.InternalSetFieldText('EX_BSMHBATH', value);
    }

    get EX_BSMOTHRM(): string {
        return this._EX_BSMOTHRM;
    }
    set EX_BSMOTHRM(value: string) {
        this._EX_BSMOTHRM = value;
        this.InternalSetFieldText('EX_BSMOTHRM', value);
    }

    get HC_HTCOOL(): string {
        return this._HC_HTCOOL;
    }
    set HC_HTCOOL(value: string) {
        this._HC_HTCOOL = value;
        this.InternalSetFieldText('HC_HTCOOL', value);
    }

    get DB_HEAT(): string {
        return this._DB_HEAT;
    }
    set DB_HEAT(value: string) {
        this._DB_HEAT = value;
        this.InternalSetFieldText('DB_HEAT', value);
    }

    get DB_COOL(): string {
        return this._DB_COOL;
    }
    set DB_COOL(value: string) {
        this._DB_COOL = value;
        this.InternalSetFieldText('DB_COOL', value);
    }

    get EE_EFFIC1(): string {
        return this._EE_EFFIC1;
    }
    set EE_EFFIC1(value: string) {
        this._EE_EFFIC1 = value;
        this.InternalSetFieldText('EE_EFFIC1', value);
    }

    get CR_GARPRK1(): string {
        return this._CR_GARPRK1;
    }
    set CR_GARPRK1(value: string) {
        this._CR_GARPRK1 = value;
        this.InternalSetFieldText('CR_GARPRK1', value);
    }

    get EX_CARNONE(): boolean {
        return this._EX_CARNONE;
    }
    set EX_CARNONE(value: boolean) {
        this._EX_CARNONE = value;
        this.InternalSetFieldText('EX_CARNONE', value == true ? 'X' : '');
    }

    get EX_GARATT(): string {
        return this._EX_GARATT;
    }
    set EX_GARATT(value: string) {
        this._EX_GARATT = value;
        this.InternalSetFieldText('EX_GARATT', value);
    }

    get EX_GARDET(): string {
        return this._EX_GARDET;
    }
    set EX_GARDET(value: string) {
        this._EX_GARDET = value;
        this.InternalSetFieldText('EX_GARDET', value);
    }

    get EX_GARBLT(): string {
        return this._EX_GARBLT;
    }
    set EX_GARBLT(value: string) {
        this._EX_GARBLT = value;
        this.InternalSetFieldText('EX_GARBLT', value);
    }

    get EX_CARPT(): string {
        return this._EX_CARPT;
    }
    set EX_CARPT(value: string) {
        this._EX_CARPT = value;
        this.InternalSetFieldText('EX_CARPT', value);
    }

    get EX_DRVWY(): string {
        return this._EX_DRVWY;
    }
    set EX_DRVWY(value: string) {
        this._EX_DRVWY = value;
        this.InternalSetFieldText('EX_DRVWY', value);
    }

    get EX_DWSURF(): string {
        return this._EX_DWSURF;
    }
    set EX_DWSURF(value: string) {
        this._EX_DWSURF = value;
        this.InternalSetFieldText('EX_DWSURF', value);
    }

    get EX_GARPRK(): string {
        return this._EX_GARPRK;
    }
    set EX_GARPRK(value: string) {
        this._EX_GARPRK = value;
        this.InternalSetFieldText('EX_GARPRK', value);
    }

    get EX_COVPRK(): string {
        return this._EX_COVPRK;
    }
    set EX_COVPRK(value: string) {
        this._EX_COVPRK = value;
        this.InternalSetFieldText('EX_COVPRK', value);
    }

    get EX_OPENPRK(): string {
        return this._EX_OPENPRK;
    }
    set EX_OPENPRK(value: string) {
        this._EX_OPENPRK = value;
        this.InternalSetFieldText('EX_OPENPRK', value);
    }

    get AB_GARPRK(): string {
        return this._AB_GARPRK;
    }
    set AB_GARPRK(value: string) {
        this._AB_GARPRK = value;
        this.InternalSetFieldText('AB_GARPRK', value);
    }

    get PF_PORPAT1(): string {
        return this._PF_PORPAT1;
    }
    set PF_PORPAT1(value: string) {
        this._PF_PORPAT1 = value;
        this.InternalSetFieldText('PF_PORPAT1', value);
    }

    get DB_PORCH(): string {
        return this._DB_PORCH;
    }
    set DB_PORCH(value: string) {
        this._DB_PORCH = value;
        this.InternalSetFieldText('DB_PORCH', value);
    }

    get DB_PATIO(): string {
        return this._DB_PATIO;
    }
    set DB_PATIO(value: string) {
        this._DB_PATIO = value;
        this.InternalSetFieldText('DB_PATIO', value);
    }

    get DB_DECK(): string {
        return this._DB_DECK;
    }
    set DB_DECK(value: string) {
        this._DB_DECK = value;
        this.InternalSetFieldText('DB_DECK', value);
    }

    get BL_BLANK1(): string {
        return this._BL_BLANK1;
    }
    set BL_BLANK1(value: string) {
        this._BL_BLANK1 = value;
        this.InternalSetFieldText('BL_BLANK1', value);
    }

    get BL_BLANK2(): string {
        return this._BL_BLANK2;
    }
    set BL_BLANK2(value: string) {
        this._BL_BLANK2 = value;
        this.InternalSetFieldText('BL_BLANK2', value);
    }

    get BL_BLANK3(): string {
        return this._BL_BLANK3;
    }
    set BL_BLANK3(value: string) {
        this._BL_BLANK3 = value;
        this.InternalSetFieldText('BL_BLANK3', value);
    }

    get HS_PRIOR1(): string {
        return this._HS_PRIOR1;
    }
    set HS_PRIOR1(value: string) {
        this._HS_PRIOR1 = value;
        this.InternalSetFieldText('HS_PRIOR1', value);
    }

    get HS_PRIOR2(): string {
        return this._HS_PRIOR2;
    }
    set HS_PRIOR2(value: string) {
        this._HS_PRIOR2 = value;
        this.InternalSetFieldText('HS_PRIOR2', value);
    }

    get HS_PRIOR3(): string {
        return this._HS_PRIOR3;
    }
    set HS_PRIOR3(value: string) {
        this._HS_PRIOR3 = value;
        this.InternalSetFieldText('HS_PRIOR3', value);
    }

    get HS_DSDATE(): string {
        return this._HS_DSDATE;
    }
    set HS_DSDATE(value: string) {
        this._HS_DSDATE = value;
        this.InternalSetFieldText('HS_DSDATE', value);
    }

    get AD_PROJECT(): string {
        return this._AD_PROJECT;
    }
    set AD_PROJECT(value: string) {
        this._AD_PROJECT = value;
        this.InternalSetFieldText('AD_PROJECT', value);
    }

    get PJ_PHASE(): string {
        return this._PJ_PHASE;
    }
    set PJ_PHASE(value: string) {
        this._PJ_PHASE = value;
        this.InternalSetFieldText('PJ_PHASE', value);
    }

    get FE_MAINT(): string {
        return this._FE_MAINT;
    }
    set FE_MAINT(value: string) {
        this._FE_MAINT = value;
        this.InternalSetFieldText('FE_MAINT', value);
    }

    get RC_FACIL1(): string {
        return this._RC_FACIL1;
    }
    set RC_FACIL1(value: string) {
        this._RC_FACIL1 = value;
        this.InternalSetFieldText('RC_FACIL1', value);
    }

    get RC_FACIL2(): string {
        return this._RC_FACIL2;
    }
    set RC_FACIL2(value: string) {
        this._RC_FACIL2 = value;
        this.InternalSetFieldText('RC_FACIL2', value);
    }

    get FL_LOC(): string {
        return this._FL_LOC;
    }
    set FL_LOC(value: string) {
        this._FL_LOC = value;
        this.InternalSetFieldText('FL_LOC', value);
    }

    private Parse(fieldName: string): void {
        this.parserExecuting = true;

        switch (fieldName) {
            case 'DB_CITY':
            case 'DB_STATE':
            case 'DB_ZIPCODE':
            case 'DB_UNITNO':
                this.BuildAddress2(fieldName);
                break;
            case 'EX_DATSRC1':
            case 'EX_DOM':
                this.BuildDataSource(fieldName);
                break;
            case 'DP_FINTYP1':
            case 'EX_OTHCONC':
            case 'EX_CONCAMT':
                this.BuildConcessions(fieldName);
                break;
            case 'RM_FBATH':
            case 'RM_HBATH':
                this.BuildBathCount();
                break;
            case 'EX_BSMSF':
            case 'EX_BSMFIN':
            case 'DP_BSMEXIT':
                this.BuildBasement(fieldName);
                break;
            case 'EX_BSMOTHRM':
            case 'EX_BSMBED':
            case 'EX_BSMBATH':
            case 'EX_BSMRECRM':
            case 'EX_BSMFBATH':
            case 'EX_BSMHBATH':
                this.BuildBasementRooms(fieldName);
                break;
            case 'DP_SITVW1':
            case 'DP_SITVW2':
            case 'EX_SITVWO2':
            case 'DP_SITVW3':
            case 'EX_SITVWO3':
                this.BuildSiteView(fieldName);
                break;
            case 'DP_LOCAT':
            case 'DP_LOC1':
            case 'EX_LOC1OTH':
            case 'DP_LOC2':
            case 'EX_LOC2OTH':
                this.BuildLocation(fieldName);
                break;
            case 'DB_COOL':
            case 'DB_HEAT':
                this.BuildHeatCool();
                break;
            case 'TP_DETACH':
            case 'TP_ATTACH':
            case 'TP_SEMIDET':
            case 'NUMSTORIES':
            case 'AB_DESAPL1':
            case 'EX_DESAPL1':
            case 'PT_DETACH':
            case 'PT_ROWTOWN':
            case 'PT_GARDEN':
            case 'PT_MIDRISE':
            case 'PT_HIRISE':
            case 'PT_OTHER':
            case 'NUMLEVELS':
                this.BuildDesignStyle();
                break;
            case 'DP_CMPTYPE':
            case 'EX_CONTKWN':
            case 'EX_CONTUNK':
            case 'EX_CONTDATE':
            case 'EX_SETTDATE':
            case 'EX_WTDRDATE':
            case 'EX_EXPRDATE':
                this.BuildDateTimeSale();
                break;
            case 'EX_CARNONE':
            case 'EX_GARATT':
            case 'EX_GARDET':
            case 'EX_GARBLT':
            case 'EX_CARPT':
            case 'EX_DRVWY':
            case 'EX_DWSURF':
            case 'EX_GARPRK':
            case 'EX_COVPRK':
            case 'EX_OPENPRK':
            case 'AB_GARPRK':
                this.BuildGarageCarport(fieldName);
                break;
            case 'DB_PORCH':
            case 'DB_PATIO':
            case 'DB_DECK':
                this.BuildPorchPatioDeck();
                break;

            // Trigger fields.
            case 'DT_SALTIM1':
                this.ParseDateTimeSale();
                break;
            case 'HC_HTCOOL':
                this.ParseHeatCool();
                break;
            case 'ST_SITEVW':
                this.ParseSiteView();
                break;
            case 'BM_BSM1':
                this.ParseBasement();
                break;
            case 'BM_BSM2':
                this.ParseBasementRooms();
                break;
            case 'AD_ADDR2':
                this.ParseAddress2();
                break;
            case 'SC_SOURCE1':
                this.ParseDataSource();
                break;
            case 'FN_CONC2':
                this.ParseConcessions();
                break;
            case 'RM_BATH':
                this.ParseBathCount();
                break;
            case 'LC_LOCAT1':
                this.ParseLocation();
                break;
            case 'DA_DESAPL1':
                this.ParseDesignStyle();
                break;
            case 'CR_GARPRK1':
                this.ParseGarageCarport();
                break;
            case 'PF_PORPAT1':
                this.ParsePorchPatioDeck();
                break;
        }
        this.parserExecuting = false;
    }

    private BuildDateTimeSale() {
        try {
            let result: string = '';
            let status: string = '';
            let unk: string = '';
            let contract = '';
            let contKwn: boolean = this._EX_CONTKWN;
            let contUnk: boolean = this._EX_CONTUNK;

            if (!this.IsEmpty(this._DP_CMPTYPE)) {
                if (PickLists.ContainsValue('DP_CMPTYPE', this._DP_CMPTYPE)) {
                    status = PickLists.GetAltText('DP_CMPTYPE', this._DP_CMPTYPE);
                }
            }

            if (status?.toLowerCase() == 's') {
                unk = 'Unk';
                contract = 'c';
            }

            if (status?.toLowerCase() == 'active') {
                result = status;
            } else if (status?.toLowerCase() == 'c') {
                result = status + this.ParseDate(this._EX_CONTDATE, this.FieldDateFormats?.get('EX_CONTDATE'));
            } else if (status?.toLowerCase() == 'e') {
                result = status + this.ParseDate(this._EX_EXPRDATE, this.FieldDateFormats?.get('EX_EXPRDATE'));
            } else if (status?.toLowerCase() == 'w') {
                result = status + this.ParseDate(this._EX_WTDRDATE, this.FieldDateFormats?.get('EX_WTDRDATE'));
            } else if (status?.toLowerCase() == 's') {
                if (contKwn == false && contUnk == false) result = status + this.ParseDate(this._EX_SETTDATE, this.FieldDateFormats?.get('EX_SETTDATE'));
                else if (contKwn == true && contUnk == false) result = status + this._EX_SETTDATE + ';' + contract + this._EX_CONTDATE;
                else if (contKwn == false && contUnk == true) result = status + this._EX_SETTDATE + ';' + unk;
            }

            this.DT_SALTIM1 = result;
        } catch (error) {
            console.log(`FieldParser.BuildDateTimeSale(), Error[${error}]`);
        }
    }

    private ParseDateTimeSale() {
        try {
            let fieldText: string = this._DT_SALTIM1;
            let fieldParts: string[];
            let status: string = '';
            let contDate: string = '';
            let expDate: string = '';
            let withDate: string = '';
            let settDate: string = '';
            let temp: string = '';
            let tempDate: number = 0;
            let valid: boolean = false;
            let contKwn: boolean = false;
            let contUnk: boolean = true;

            if (!this.IsEmpty(fieldText)) {
                fieldParts = fieldText.split(';');
                temp = fieldParts[0].toLowerCase();

                if (temp == 'active') {
                    status = 'Active';
                    valid = true;
                } else {
                    switch (temp?.substring(0, 1)) {
                        case 'a':
                            status = 'Active';
                            break;
                        case 'c':
                            status = 'Contract';
                            contDate = temp.substring(1);
                            valid = this.IsValidDate(contDate);
                            break;
                        case 'e':
                            status = 'Expired';
                            expDate = temp.substring(1);
                            valid = this.IsValidDate(expDate);
                            break;
                        case 'w':
                            status = 'Withdrawn';
                            withDate = temp.substring(1);
                            valid = this.IsValidDate(withDate);
                            break;
                        case 's':
                            status = 'Settled sale';
                            settDate = temp.substring(1);
                            valid = this.IsValidDate(settDate);
                            if (fieldParts.length > 1) {
                                temp = fieldParts[1].trim().toLowerCase();
                                if (!this.IsEmpty(temp)) {
                                    if (temp.substring(0, 1) == 'c') {
                                        contDate = this.ParseDate(temp.substring(1), 'MMYY');
                                        contKwn = true;
                                        contUnk = false;
                                    }
                                }
                            }
                            break;
                    }
                }

                if (valid) {
                    this.DP_CMPTYPE = status;
                    this.EX_CONTKWN = contKwn;
                    this.EX_CONTUNK = contUnk;
                    this.EX_CONTDATE = contDate;
                    this.EX_SETTDATE = settDate;
                    this.EX_WTDRDATE = withDate;
                    this.EX_EXPRDATE = expDate;
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseDateTimeSale(), Error[${error}]`);
        }
    }

    private BuildHeatCool() {
        try {
            let heat: string = this._DB_HEAT;
            let cool: string = this._DB_COOL;

            if (!this.IsEmpty(heat) && !this.IsEmpty(cool)) this.HC_HTCOOL = heat + ',' + cool;
            else if (!this.IsEmpty(heat)) this.HC_HTCOOL = heat;
            else if (!this.IsEmpty(cool)) this.HC_HTCOOL = cool;
            else this.HC_HTCOOL = '';
        } catch (error) {
            console.log(`FieldParser.BuildHeatCool(), Error[${error}]`);
        }
    }

    private ParseHeatCool() {
        try {
            let parts: string[] = [''];
            if (!this.IsEmpty(this._HC_HTCOOL)) {
                parts = this._HC_HTCOOL.split(',');
                if (parts?.length == 2) {
                    this.DB_HEAT = parts[0];
                    this.DB_COOL = parts[1];
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseHeatCool(), Error[${error}]`);
        }
    }

    private BuildSiteView(fieldName: string): void {
        try {
            let result: string = '';
            let overall: string = '';
            let factor1: string = '';
            let factor2: string = '';
            let other1: string = '';
            let other2: string = '';
            var validateFactor = { factor: '', desc: '' };

            if (!PickLists.ContainsValue('DP_SITVW1', this._DP_SITVW1)) this.DP_SITVW1 = '';

            if (!this.IsEmpty(this._DP_SITVW1)) if (PickLists.ContainsValue('DP_SITVW1', this._DP_SITVW1)) overall = PickLists.GetAltText('DP_SITVW1', this._DP_SITVW1);

            if (!this.IsEmpty(this._DP_SITVW2)) {
                factor1 = this._DP_SITVW2;
                validateFactor = { factor: factor1, desc: other1 };
                this.ValidateViewFactor(validateFactor);

                factor1 = PickLists.GetAltText('DP_SITVW2', validateFactor.factor);
                if (String(factor1)?.toLowerCase().startsWith('o')) {
                    factor1 = this._EX_SITVWO2;
                }
            } else {
                factor1 = this._EX_SITVWO2;
            }

            if (!this.IsEmpty(this._DP_SITVW3)) {
                factor2 = this._DP_SITVW3;
                validateFactor = { factor: factor2, desc: other2 };
                this.ValidateViewFactor(validateFactor);
                factor2 = PickLists.GetAltText('DP_SITVW3', validateFactor.factor);

                if (String(factor2)?.toLowerCase().startsWith('o')) {
                    factor2 = this._EX_SITVWO3;
                }
            } else {
                factor2 = this._EX_SITVWO3;
            }

            if (!this.IsEmpty(overall) && this.IsEmpty(factor1) && this.IsEmpty(factor2)) {
                result = '';
            } else {
                if (!this.IsEmpty(factor1) && this.IsEmpty(factor2)) {
                    result = overall + ';' + factor1 + ';';
                } else {
                    result = overall + ';' + factor1 + ';' + factor2;
                }
            }

            let re = /;/gi;
            let tmp: string = result.replace(re, '').trim();
            if (tmp.length == 0) result = '';

            this.ST_SITEVW = result;
        } catch (error) {
            console.log(`FieldParser.BuildSiteView(), Error[${error}]`);
        }
    }

    private ParseSiteView() {
        try {
            let fieldText: string = this._ST_SITEVW;
            let overall: string = '';
            let factor1: string = '';
            let factor2: string = '';
            let other1: string = '';
            let other2: string = '';
            let valid: boolean = true;
            let fieldParts: string[];
            let items: number = 0;
            var validateFactor = { factor: '', desc: '' };

            if (!this.IsEmpty(fieldText)) {
                fieldParts = fieldText.split(';');
                items = fieldParts.length;
                overall = fieldParts[0];
                validateFactor = { factor: overall, desc: other1 };
                this.ValidateViewFactor(validateFactor);
                overall = validateFactor.factor;

                if (items == 1) {
                    valid = false;
                } else {
                    if (items > 1) {
                        factor1 = fieldParts[1].trim();
                        validateFactor = { factor: factor1, desc: other1 };
                        this.ValidateViewFactor(validateFactor);
                        factor1 = validateFactor.factor;
                        other1 = validateFactor.desc;
                    }
                    if (items > 2) {
                        if (fieldParts.length > 0) {
                            factor2 = fieldParts[2].trim();
                            validateFactor = { factor: factor2, desc: other2 };
                            this.ValidateViewFactor(validateFactor);
                            factor2 = validateFactor.factor;
                            other2 = validateFactor.desc;
                        }
                    }
                }

                if (valid) {
                    this.DP_SITVW1 = overall;
                    this.DP_SITVW2 = factor1;
                    this.EX_SITVWO2 = other1;
                    this.DP_SITVW3 = factor2;
                    this.EX_SITVWO3 = other2;
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseSiteView(), Error[${error}]`);
        }
    }

    private BuildBasement(fieldName: string): void {
        try {
            let result: string = '';
            let basementSF: string = 'sf';
            let basementFinSF: string = 'sf';
            let bsmSf: string = this._EX_BSMSF;
            let bsmFinSf: string = this._EX_BSMFIN;
            let bsmExit: string = this._DP_BSMEXIT;
            let lookupExit: string = '';

            if (bsmSf == '0') {
                bsmFinSf = '0';
                basementFinSF = '';
            } else {
                basementSF = 'sf';
            }

            if (this.IsEmpty(bsmSf) && this.IsEmpty(bsmFinSf) && this.IsEmpty(bsmExit)) {
                result = '';
            } else {
                if (this.IsEmpty(bsmFinSf)) {
                    basementFinSF = '';
                }
                if (bsmSf == '0') {
                    bsmFinSf = '';
                    basementFinSF = '';
                    bsmExit = '';
                }

                // Only use table value if a match is found.
                lookupExit = PickLists.GetAltText('EX_BSMEXIT', bsmExit);
                if (!this.IsEmpty(lookupExit)) bsmExit = lookupExit;

                result = bsmSf + basementSF + bsmFinSf + basementFinSF + bsmExit;
                this.BM_BSM1 = result;

                if (bsmSf == '0' || bsmFinSf == '0') this.BuildBasementRooms(fieldName);
            }
        } catch (error) {
            console.log(`FieldParser.BuildBasement(), Error[${error}]`);
        }
    }

    private ParseBasement() {
        try {
            let fieldText: string = this._BM_BSM1;
            let fieldParts: string[];
            let temp: string = '';
            let area: string = '';
            let finished: string = '';
            let exit: string = '';
            let items: number = 0;
            let valid: boolean = false;

            valid = fieldText?.includes('sf');

            if (valid) {
                fieldParts = fieldText.split('sf');
                items = fieldParts.length;
                area = fieldParts[0];

                if (items > 1) {
                    finished = fieldParts[1];
                }
                if (items > 2) {
                    temp = fieldParts[2]?.toLowerCase();
                    switch (temp) {
                        case 'wo':
                            exit = 'Walk-out';
                            break;
                        case 'wu':
                            exit = 'Walk-up';
                            break;
                        case 'in':
                            exit = 'Interior-only';
                            break;
                    }
                }

                valid = this.IsDigitOnlyContent(fieldParts[0]?.trim());

                if (valid) {
                    this.EX_BSMSF = area;
                    this.EX_BSMFIN = finished == '' ? '0' : finished;
                    this.DP_BSMEXIT = exit;
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseBasement(), Error[${error}]`);
        }
    }

    private ParseAddress2() {
        try {
            let fieldText: string = this._AD_ADDR2;
            let parts: string[];
            let remaining: string = '';
            let stateTemp: string = '';
            let zipTemp: string = '';
            let count: number = 0;
            let remainingCount: number = 0;
            let unitNo: string = '';
            let city: string = '';
            let state: string = '';
            let zip: string = '';

            if (this.IsEmpty(fieldText)) {
                return;
            }

            parts = fieldText?.split(',');

            if (parts?.length == 3) {
                unitNo = parts[0];
                city = parts[1].trim();
                remaining = parts[2];
            } else if (parts?.length == 2) {
                city = parts[0];
                remaining = parts[1];
            } else {
                return;
            }

            parts = remaining?.trim().split(' ');

            if (parts?.length > 0) {
                for (count = 0; count < parts.length; count++) {
                    if (parts[count].trim().length > 0) {
                        remainingCount++;

                        if (this.IsEmpty(stateTemp)) {
                            stateTemp = parts[count];
                        } else {
                            zipTemp = parts[count];
                        }
                    }
                }

                if (remainingCount == 2) {
                    state = stateTemp;
                    zip = zipTemp;
                }
            }

            this.DB_UNITNO = unitNo;
            this.DB_CITY = city;
            this.DB_STATE = state;
            this.DB_ZIPCODE = zip;
        } catch (error) {
            console.log(`FieldParser.ParseAddress2(), Error[${error}]`);
        }
    }

    private BuildBasementRooms(fieldName: string) {
        try {
            let result: string = '';
            let bsmRR: string = 'rr';
            let bsmBR: string = 'br';
            let bsmBA: string = 'ba';
            let bsmO: string = 'o';
            let zeroRooms: boolean = this._EX_BSMSF == '0' || this._EX_BSMFIN == '0';

            if (!this.IsEmpty(this._EX_BSMRECRM) || !this.IsEmpty(this._EX_BSMBED) || !this.IsEmpty(this._EX_BSMBATH) || !this.IsEmpty(this._EX_BSMOTHRM) || zeroRooms) {
                let bsmRecRm: string = this.IsEmpty(this._EX_BSMRECRM) ? '0' : this._EX_BSMRECRM;
                let bsmBed: string = this.IsEmpty(this._EX_BSMBED) ? '0' : this._EX_BSMBED;
                let bsmBath: string = this.IsEmpty(this._EX_BSMBATH) ? '0' : this._EX_BSMBATH;
                let bsmOthRm: string = this.IsEmpty(this._EX_BSMOTHRM) ? '0' : this._EX_BSMOTHRM;

                if (zeroRooms) {
                    this.EX_BSMRECRM = '0';
                    this.EX_BSMBED = '0';
                    this.EX_BSMBATH = '0.0';
                    this.EX_BSMOTHRM = '0';
                    this.EX_BSMFBATH = '0';
                    this.EX_BSMHBATH = '0';
                } else {
                    if (fieldName?.endsWith('EX_BSMFBATH') || fieldName?.endsWith('EX_BSMHBATH')) {
                        bsmBath = (this.IsEmpty(this._EX_BSMFBATH) ? '0' : this._EX_BSMFBATH) + '.' + (this.IsEmpty(this._EX_BSMHBATH) ? '0' : this._EX_BSMHBATH);
                        this.EX_BSMBATH = bsmBath;
                        result = bsmRecRm + bsmBR + bsmBed + bsmBR + bsmBath + bsmBA + bsmOthRm + bsmO;
                    } else {
                        if (!this.IsEmpty(this._EX_BSMBATH)) {
                            bsmBath = this._EX_BSMBATH;
                            let aParts: string[] = bsmBath?.split('.');

                            if (aParts?.length == 2) {
                                this._EX_BSMFBATH = aParts[0];
                                this._EX_BSMHBATH = aParts[1];
                            }
                        }
                    }
                    result = bsmRecRm + bsmRR + bsmBed + bsmBR + bsmBath + bsmBA + bsmOthRm + bsmO;
                }
            }

            if (this._EX_BSMRECRM == '0' && this._EX_BSMBED == '0' && this._EX_BSMBATH == '0.0' && this._EX_BSMOTHRM == '0') {
                if (zeroRooms) {
                    this.BM_BSM2 = '';
                } else {
                    this.BM_BSM2 = result;
                }
            } else {
                this.BM_BSM2 = result;
            }
        } catch (error) {
            console.log(`FieldParser.BuildBasementRooms(), Error[${error}]`);
        }
    }

    private ParseBasementRooms() {
        try {
            let fieldText = this._BM_BSM2;
            let fieldParts: string[];
            let rr: number = 0;
            let br: number = 0;
            let ba: number = 0;
            let oo: number = 0;
            let temp: string = '';
            let recRooms: string = '';
            let bedRooms: string = '';
            let bathRooms: string = '';
            let otherRooms: string = '';
            let valid: boolean = false;

            valid = fieldText?.includes('rr') || fieldText?.includes('br') || fieldText?.includes('ba') || fieldText?.includes('o');

            if (valid) {
                recRooms = this.GetRooms(fieldText, 'rr');
                bedRooms = this.GetRooms(fieldText, 'br');
                bathRooms = this.GetRooms(fieldText, 'ba');
                otherRooms = this.GetRooms(fieldText, 'o');

                this.BuildBasementRooms('BM_BSM2');
            }

            this.EX_BSMRECRM = recRooms;
            this.EX_BSMBED = bedRooms;
            this.EX_BSMBATH = bathRooms;
            this.EX_BSMOTHRM = otherRooms;
        } catch (error) {
            console.log(`FieldParser.ParseBasementRooms(), Error[${error}]`);
        }
    }

    private GetRooms(rooms: string, delimter: string): string {
        let result: string = '';

        try {
            let i: number = 0;
            let j: number = 0;
            let ch: string = '';

            i = rooms?.toLowerCase().indexOf(delimter);

            if (i > 0) {
                for (j = i - 1; j > -1; j--) {
                    ch = rooms.charAt(j);

                    if (ch == '.' || ch == ',' || this.IsDigitOnlyContent(ch)) {
                        result = ch + result;
                    } else {
                        break;
                    }
                }
            }

            if (result?.length == 0) {
                if (delimter.toLowerCase() == 'ba') {
                    result = '0.0';
                } else {
                    result = '0';
                }
            }
        } catch (error) {
            console.log(`FieldParser.GetRooms(), Error[${error}]`);
        }

        return result;
    }

    private BuildAddress2(fieldName: string): void {
        try {
            if (this.IsEmpty(this._DB_CITY) && this.IsEmpty(this._DB_STATE) && this.IsEmpty(this._DB_ZIPCODE) && this.IsEmpty(this._DB_UNITNO)) {
                this._AD_ADDR2 = '';
            } else if (!this.IsEmpty(this._DB_UNITNO)) {
                if (!this.IsEmpty(this._DB_CITY) || !this.IsEmpty(this._DB_STATE) || !this.IsEmpty(this._DB_ZIPCODE)) {
                    this.AD_ADDR2 = this._DB_UNITNO + ', ' + this._DB_CITY + ', ' + this.DB_STATE + ' ' + this._DB_ZIPCODE;
                }
            } else if (!this.IsEmpty(this._DB_CITY) || !this.IsEmpty(this._DB_STATE) || !this.IsEmpty(this._DB_ZIPCODE)) {
                this.AD_ADDR2 = this._DB_CITY + ', ' + this._DB_STATE + ' ' + this._DB_ZIPCODE;
            }
        } catch (error) {
            console.log(`FieldParser.BuildAddress2(), Error[${error}]`);
        }
    }

    private BuildDataSource(fieldName: string): void {
        try {
            if (this._EX_DATSRC1?.length > 0 && this._EX_DOM?.length == 0) {
                this.SC_SOURCE1 = this._EX_DATSRC1 + ';DOM';
            } else if (this._EX_DATSRC1?.length == 0 && this._EX_DOM?.length > 0) {
                this.SC_SOURCE1 = ';DOM ' + this._EX_DOM;
            } else if (this._EX_DATSRC1?.length > 0 && this._EX_DOM?.length > 0) {
                this.SC_SOURCE1 = this._EX_DATSRC1 + ';DOM ' + this._EX_DOM;
            }
        } catch (error) {
            console.log(`FieldParser.BuildDataSource(), Error[${error}]`);
        }
    }

    private ParseDataSource() {
        try {
            let i: number = 0;
            let fieldText: string = this._SC_SOURCE1;
            let parts: string[];
            let dataSource: string = '';
            let dom: string = '';
            let valid: boolean = false;

            if (this.IsEmpty(fieldText)) {
                return;
            }

            valid = fieldText?.includes(';');
            i = fieldText?.lastIndexOf(';');

            if (i > 0) {
                dataSource = fieldText.substring(0, i).trim();
                dom = fieldText.substring(i + 1).trim();

                if (String(dom)?.toLowerCase().startsWith('dom')) {
                    if (dom.length > 3) {
                        dom = dom.substring(4);
                    } else {
                        dom = '';
                    }
                }
            } else {
                dataSource = '';
                dom = fieldText?.substring(i + 1).trim();

                if (String(dom)?.toLowerCase().startsWith('dom')) {
                    if (dom.length > 3) {
                        dom = dom.substring(4);
                    } else {
                        dom = '';
                    }
                }
            }

            this.EX_DATSRC1 = dataSource;
            this.EX_DOM = dom;
        } catch (error) {
            console.log(`FieldParser.ParseDataSource(), Error[${error}]`);
        }
    }

    private ParseConcessions(): void {
        try {
            let finType: string = '';
            let other: string = '';
            let concAmt: string = '';
            let parts: string[] = [''];
            let valid: boolean = false;

            valid = this._FN_CONC2?.indexOf(';') > 0;

            if (valid) {
                if (!this.IsEmpty(this._FN_CONC2)) {
                    parts = this._FN_CONC2.split(';');

                    finType = parts[0]?.trim();

                    switch (finType?.toLowerCase()) {
                        case 'fha':
                            finType = 'FHA';
                            break;
                        case 'va':
                            finType = 'VA';
                            break;
                        case 'conventional':
                        case 'conv':
                            finType = 'Conventional';
                            break;
                        case 'seller':
                            finType = 'Seller';
                            break;
                        case 'cash':
                            finType = 'Cash';
                            break;
                        case 'rh':
                        case 'rural':
                        case 'rural housing':
                        case 'usda':
                        case 'usda - rural housing':
                            finType = 'USDA - Rural Housing';
                            break;
                        default:
                            if (parts?.length == 0 && finType?.length > 0 && !isNaN(Number(finType))) {
                                concAmt = finType;
                                finType = '';
                                other = '';
                            } else {
                                other = finType;
                                finType = 'Other (describe)';
                            }
                            break;
                    }

                    if (parts?.length > 0) {
                        concAmt = parts[1].trim();
                    }
                }
            } else {
                if (this._FN_CONC2?.indexOf(';') == 0) {
                    if (this._FN_CONC2.length > 1) {
                        concAmt = this._FN_CONC2.substring(1);
                    } else {
                        concAmt = '';
                    }
                }
            }

            this.DP_FINTYP1 = finType;
            this.EX_OTHCONC = other;
            this.EX_CONCAMT = concAmt;
        } catch (error) {
            console.log(`FieldParser.ParseConcessions(), Error[${error}]`);
        }
    }

    private BuildConcessions(fieldName: string): void {
        try {
            let segment1: string = '';

            if (PickLists.ContainsValue('DP_FINTYP1', this._DP_FINTYP1)) {
                segment1 = PickLists.GetAltText('DP_FINTYP1', this._DP_FINTYP1);
            } else {
                segment1 = this._EX_OTHCONC;
            }
            if (segment1 == 'OTH') {
                segment1 = this._EX_OTHCONC;
            }

            if (!this.IsEmpty(segment1) || !this.IsEmpty(this._EX_CONCAMT)) {
                this.FN_CONC2 = segment1 + ';' + this._EX_CONCAMT;
            }
        } catch (error) {
            console.log(`FieldParser.BuildConcessions(), Error[${error}]`);
        }
    }

    private BuildBathCount(): void {
        try {
            const fullBaths = this.IsEmpty(this._RM_FBATH) ? '0' : this._RM_FBATH;
            const halfBaths = this.IsEmpty(this._RM_HBATH) ? '0' : this._RM_HBATH;

            this.RM_BATH = fullBaths === '0' && halfBaths === '0' ? '' : `${fullBaths}.${halfBaths}`;
        } catch (error) {
            console.log(`FieldParser.BuildBathCount(), Error[${error}]`);
        }
    }

    private ParseBathCount(): void {
        try {
            let parts: string[] = [''];
            if (!this.IsEmpty(this._RM_BATH)) {
                parts = this._HC_HTCOOL.split('.');
                if (parts?.length == 2) {
                    this.RM_FBATH = parts[0];
                    this.RM_HBATH = parts[1];
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseBathCount(), Error[${error}]`);
        }
    }

    private ParseLocation(): void {
        try {
            let fieldText: string = '';
            let overall: string = '';
            let factor1: string = '';
            let desc1: string = '';
            let factor2: string = '';
            let desc2: string = '';
            let itemCount: Number = 0;
            let split: string[] = [''];
            let valid: boolean = true;
            var validateFactor = { factor: '', desc: '' };

            fieldText = this.LC_LOCAT1;

            if (!this.IsEmpty(fieldText)) {
                split = fieldText.split(';');
                itemCount = split?.length;

                overall = this.GetOverallFactor(split[0]?.trim());

                if (itemCount == 1) {
                    valid = false;
                } else {
                    if (itemCount > 1) {
                        factor1 = split[1]?.trim();
                        validateFactor = { factor: factor1, desc: desc1 };
                        this.ValidateLocationFactor(validateFactor);
                        factor1 = validateFactor.factor;
                        desc1 = validateFactor.desc;
                    }

                    if (itemCount > 2) {
                        if (split[2]?.length > 0) {
                            factor2 = split[2].trim();
                            validateFactor = { factor: factor2, desc: desc2 };
                            this.ValidateLocationFactor(validateFactor);
                            factor2 = validateFactor.factor;
                            desc2 = validateFactor.desc;
                        }
                    }
                }
            }

            if (valid) {
                this.DP_LOCAT = overall;
                this.DP_LOC1 = factor1;
                this.EX_LOC1OTH = desc1;
                this.DP_LOC2 = factor2;
                this.EX_LOC2OTH = desc2;
            }
        } catch (error) {
            console.log(`FieldParser.ParseLocation(), Error[${error}]`);
        }
    }

    private BuildLocation(fieldName: string): void {
        try {
            let factor1: string = '';
            let factor2: string = '';
            let overall: string = '';
            let result: string = '';

            if (PickLists.ContainsValue('DP_LOCAT', this.DP_LOCAT)) {
                overall = PickLists.GetAltText('DP_LOCAT', this.DP_LOCAT);
            } else {
                overall = this._DP_LOCAT;
            }

            if (PickLists.ContainsValue('DP_LOC1', this._DP_LOC1)) {
                factor1 = PickLists.GetAltText('DP_LOC1', this._DP_LOC1);
            } else {
                factor1 = this._EX_LOC1OTH;
            }
            if (factor1 == 'OTH') {
                factor1 = this._EX_LOC1OTH;
            }

            if (PickLists.ContainsValue('DP_LOC2', this._DP_LOC2)) {
                factor2 = PickLists.GetAltText('DP_LOC2', this._DP_LOC2);
            } else {
                factor2 = this._EX_LOC2OTH;
            }
            if (factor2 == 'OTH') {
                factor2 = this._EX_LOC2OTH;
            }

            if (this.IsEmpty(overall) && this.IsEmpty(factor1) && this.IsEmpty(factor2)) {
                result = '';
            } else {
                if (factor2?.length > 0 && factor1?.length == 0) {
                    result = overall + ';' + ';' + factor2;
                } else {
                    result = overall + ';' + factor1 + ';' + factor2;
                }
            }

            this.LC_LOCAT1 = result;
        } catch (error) {
            console.log(`FieldParser.BuildLocation(), Error[${error}]`);
        }
    }

    private BuildDesignStyle(): void {
        try {
            let result: string = '';

            if (this._TP_ATTACH) {
                result = 'AT';
            } else if (this._TP_DETACH) {
                result = 'DT';
            } else if (this._TP_SEMIDET) {
                result = 'SD';
            } else if (this._PT_DETACH) {
                result = 'DT';
            } else if (this._PT_ROWTOWN) {
                result = 'RT';
            }
            if (this._PT_GARDEN) {
                result = 'GR';
            } else if (this._PT_MIDRISE) {
                result = 'MR';
            } else if (this._PT_HIRISE) {
                result = 'HR';
            } else if (this._PT_OTHER) {
                result = 'O';
            }

            this._NUMSTORIES = String(this._NUMSTORIES);
            if (this._NUMSTORIES?.length > 0) {
                result += this._NUMSTORIES;
            }

            if (this._NUMLEVELS?.length > 0) {
                result += this._NUMLEVELS;
                result += 'L';
            }

            if (this._AB_DESAPL1?.length > 0) {
                result += ';';
                result += this._AB_DESAPL1;
            } else if (this._EX_DESAPL1?.length > 0) {
                result += ';';
                result += this._EX_DESAPL1;
            }

            this.DA_DESAPL1 = result;
        } catch (error) {
            console.log(`FieldParser.BuildDesignStyle(), Error[${error}]`);
        }
    }

    private ParseDesignStyle(): void {
        try {
            let triggerText: string = '';
            let val: string = '';
            let parts: string[] = [''];
            let isCondo: boolean = false;

            this._TP_ATTACH = false;
            this._TP_DETACH = false;
            this._TP_SEMIDET = false;
            this._PT_DETACH = false;
            this._PT_GARDEN = false;
            this._PT_MIDRISE = false;
            this._PT_HIRISE = false;
            this._PT_ROWTOWN = false;
            this._PT_OTHER = false;
            this._AB_DESAPL1 = '';

            triggerText = this._DA_DESAPL1;
            parts = triggerText?.split(';');

            if (parts?.length > 0) {
                parts[0] = String(parts[0]);
                if (parts[0]?.toLowerCase().startsWith('dt') && !parts[0]?.toLowerCase().endsWith('l')) {
                    this.TP_DETACH = true;
                    this.PT_DETACH = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('at')) {
                    this.TP_ATTACH = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('sd')) {
                    this._TP_SEMIDET = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('dt') && parts[0]?.toLowerCase().endsWith('l')) {
                    isCondo = true;
                    this.PT_DETACH = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('rt')) {
                    isCondo = true;
                    this.PT_ROWTOWN = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('gr')) {
                    isCondo = true;
                    this.PT_GARDEN = true;
                    val = parts[0].substr(2);
                }
                if (parts[0]?.toLowerCase().startsWith('mr')) {
                    isCondo = true;
                    this._PT_MIDRISE = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('hr')) {
                    isCondo = true;
                    this.PT_HIRISE = true;
                    val = parts[0].substr(2);
                }

                if (parts[0]?.toLowerCase().startsWith('o')) {
                    isCondo = true;
                    this.PT_OTHER = true;
                    val = parts[0].substr(1);
                }
            }

            if (isCondo && val?.length != 0) {
                this.NUMLEVELS = val;
            } else if (val?.length != 0) {
                this.NUMSTORIES = val;
            } else {
                this.NUMSTORIES = '';
                this.NUMLEVELS = '';
            }

            if (parts?.length > 1) {
                this.AB_DESAPL1 = parts[1];
            }
        } catch (error) {
            console.log(`FieldParser.ParseDesignStyle(), Error[${error}]`);
        }
    }

    private ParseGarageCarport() {
        try {
            let triggertext: string = '';
            let match: string = '';
            let value: string = '';
            let matches: string[] = [''];
            let regexpSF: RegExp = /([0-9\.]+)ga|([0-9\.]+)gd|([0-9\.]+)gbi|([0-9\.]+)cp|([0-9\.]+)dw/gi;
            let regexpCondo: RegExp = /([0-9\.]+)g(?!a)(?!b)(?!d)|([0-9\.]+)cv|([0-9\.]+)op/gi;

            triggertext = this._CR_GARPRK1;

            if (triggertext?.toUpperCase() == 'NONE') {
                this.CR_GARPRK1 = 'None';
                this.EX_CARNONE = true;
                this.EX_GARATT = '0';
                this.EX_GARDET = '0';
                this.EX_GARBLT = '0';
                this.EX_CARPT = '0';
                this.EX_DRVWY = '0';
                this.EX_GARPRK = '0';
                this.EX_COVPRK = '0';
                this.EX_OPENPRK = '0';
                this.AB_GARPRK = '';
            } else {
                matches = this._CR_GARPRK1?.match(regexpSF);

                if (matches?.length > 0) {
                    this.EX_CARNONE = false;
                    this.EX_GARATT = '';
                    this.EX_GARDET = '';
                    this.EX_GARBLT = '';
                    this.EX_CARPT = '';
                    this.EX_DRVWY = '';

                    for (let matchValue of matches) {
                        match = matchValue.replace(/[0-9]/g, '').toLowerCase();
                        value = matchValue.replace(/\D/g, '').toLowerCase();

                        if (!this.IsEmpty(value)) {
                            if (match == 'ga') this.EX_GARATT = value;
                            else if (this.IsEmpty(this._EX_GARATT)) this.EX_GARATT = '';

                            if (match == 'gd') this.EX_GARDET = value;
                            else if (this.IsEmpty(this._EX_GARDET)) this.EX_GARDET = '';

                            if (match == 'gbi') this.EX_GARBLT = value;
                            else if (this.IsEmpty(this._EX_GARBLT)) this.EX_GARBLT = '';

                            if (match == 'cp') this.EX_CARPT = value;
                            else if (this.IsEmpty(this._EX_CARPT)) this.EX_CARPT = '';

                            if (match == 'dw') this.EX_DRVWY = value;
                            else if (this.IsEmpty(this._EX_DRVWY)) this.EX_DRVWY = '';
                        }
                    }
                } else {
                    //maybe a condo?
                    let parts: string[] = triggertext.split(';');
                    matches = parts[0]?.match(regexpCondo);

                    if (matches?.length > 0) {
                        this.EX_CARNONE = false;
                        this.EX_GARPRK = '';
                        this.EX_COVPRK = '';
                        this.EX_OPENPRK = '';
                        this.AB_GARPRK = '';

                        for (let matchValue of matches) {
                            match = matchValue.replace(/[0-9]/g, '').toLowerCase();
                            value = matchValue.replace(/\D/g, '').toLowerCase();

                            if (!this.IsEmpty(value)) {
                                if (match == 'g') this.EX_GARPRK = value;
                                else if (this.IsEmpty(this._EX_GARPRK)) this.EX_GARPRK = '';

                                if (match == 'cv') this.EX_COVPRK = value;
                                else if (this.IsEmpty(this._EX_COVPRK)) this.EX_COVPRK = '';

                                if (match == 'op') this.EX_OPENPRK = value;
                                else if (this.IsEmpty(this._EX_OPENPRK)) this.EX_OPENPRK = '';
                            }
                        }
                    }

                    if (parts?.length > 1 && !this.IsEmpty(parts[1])) {
                        this.AB_GARPRK = parts[1];
                    }
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseGarageCarport(), Error[${error}]`);
        }
    }

    private NotEmptyOrZero(value: string): boolean {
        return !this.IsEmpty(value) && value != '0';
    }

    private BuildGarageCarport(fieldName: string): void {
        try {
            if (fieldName == 'EX_DWSURF') return;

            if (String(this._EX_CARNONE) == 'true') {
                this.CR_GARPRK1 = 'None';

                if (!this.IsEmpty(this._AB_GARPRK)) this.CR_GARPRK1 += `;${this._AB_GARPRK}`;

                return;
            }

            let result: string = '';

            if (this.NotEmptyOrZero(this._EX_GARPRK)) result = `${this._EX_GARPRK}g`;

            if (this.NotEmptyOrZero(this._EX_COVPRK)) result += `${this._EX_COVPRK}cv`;

            if (this.NotEmptyOrZero(this._EX_OPENPRK)) result += `${this._EX_OPENPRK}op`;

            if (!this.IsEmpty(this._AB_GARPRK)) result += `;${this._AB_GARPRK}`;

            if (this.NotEmptyOrZero(this._EX_GARATT)) result = `${this._EX_GARATT}ga`;

            if (this.NotEmptyOrZero(this._EX_GARDET)) result += `${this._EX_GARDET}gd`;

            if (this.NotEmptyOrZero(this._EX_GARBLT)) result += `${this._EX_GARBLT}gbi`;

            if (this.NotEmptyOrZero(this._EX_CARPT)) result += `${this._EX_CARPT}cp`;

            if (this.NotEmptyOrZero(this._EX_DRVWY)) result += `${this._EX_DRVWY}dw`;

            this.CR_GARPRK1 = result;
        } catch (error) {
            console.log(`FieldParser.BuildGarageCarport(), Error[${error}]`);
        }
    }

    private BuildPorchPatioDeck(): void {
        try {
            let porch: string = this._DB_PORCH;
            let patio: string = this._DB_PATIO;
            let deck: string = this._DB_DECK;

            if (!this.IsEmpty(porch) && !this.IsEmpty(patio) && !this.IsEmpty(deck)) this.PF_PORPAT1 = porch + ',' + patio + ',' + deck;
            else if (!this.IsEmpty(porch) && !this.IsEmpty(patio)) this.PF_PORPAT1 = porch + ',' + patio;
            else if (!this.IsEmpty(porch) && !this.IsEmpty(deck)) this.PF_PORPAT1 = porch + ',' + deck;
            else if (!this.IsEmpty(patio) && !this.IsEmpty(deck)) this.PF_PORPAT1 = patio + ',' + deck;
            else if (!this.IsEmpty(porch)) this.PF_PORPAT1 = porch;
            else if (!this.IsEmpty(patio)) this.PF_PORPAT1 = patio;
            else if (!this.IsEmpty(deck)) this.PF_PORPAT1 = deck;
            else this.PF_PORPAT1 = '';
        } catch (error) {
            console.log(`FieldParser.BuildPorchPatioDeck(), Error[${error}]`);
        }
    }

    private ParsePorchPatioDeck(): void {
        try {
            let parts: string[] = [''];
            if (!this.IsEmpty(this._PF_PORPAT1)) {
                this._PF_PORPAT1 = this._PF_PORPAT1.toString();
                parts = this._PF_PORPAT1.split(',');
                if (parts?.length == 3) {
                    this.DB_PORCH = parts[0];
                    this.DB_PATIO = parts[1];
                    this.DB_DECK = parts[2];
                } else if (parts?.length == 2) {
                    this.DB_PORCH = parts[0];
                    this.DB_PATIO = parts[1];
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParsePorchPatioDeck(), Error[${error}]`);
        }
    }

    private IsEmpty(value: string): boolean {
        if (typeof value != 'undefined' && value) return false;
        else return true;
    }

    /*
     * Determine if string contains a date and convert to UAD format "MM/yy";
     */
    private ParseDate(value: string, format: string): string {
        let result: string = value;

        try {
            value = value?.replace(/\\/gi, '/');
            let delimiters: string[] = ['-', '/'];
            let dateParts: string[];
            let tmpVal: string = '';
            let date: Date;
            var options;
            let year: number = 2020;
            let month: number = 1;
            let day: number = 1;

            if (this.IsValidDate(value)) {
                dateParts = value?.split(new RegExp(delimiters.join('|'), 'g'));
                if (dateParts?.length == 2) {
                    if (dateParts[1]?.length == 2) dateParts[1] = '20' + dateParts[1];
                    year = Number.parseInt(dateParts[1]);
                    // Why is month zero based??
                    month = Number.parseInt(dateParts[0]) - 1;
                    date = new Date(year, month, day);
                } else if (dateParts?.length == 3) {
                    if (dateParts[2]?.length == 2) dateParts[2] = '20' + dateParts[2];
                    year = Number.parseInt(dateParts[2]);
                    // Why is month zero based??
                    month = Number.parseInt(dateParts[0]) - 1;
                    day = Number.parseInt(dateParts[1]);
                    date = new Date(year, month, day);
                }

                switch (format) {
                    case 'MMDDYYYY':
                        options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                        result = date?.toLocaleDateString('us-EN', options);
                        break;

                    case 'YYYYMMDD':
                        options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                        tmpVal = date?.toLocaleDateString('us-EN', options);
                        dateParts = tmpVal?.split('/');
                        if (dateParts?.length == 3) result = dateParts[2] + '/' + dateParts[0] + '/' + dateParts[1];
                        break;

                    case 'YYYY':
                        options = { year: 'numeric' };
                        result = date?.toLocaleDateString('us-EN', options);
                        break;

                    case 'MMYY':
                        options = { year: '2-digit', month: '2-digit' };
                        result = date?.toLocaleDateString('us-EN', options);
                        break;
                    default:
                        break;
                }
            }
        } catch (error) {
            console.log(`FieldParser.ParseDate(), Error[${error}]`);
        }

        return result;
    }

    private ValidateViewFactor(model: { factor: string; desc: string }): boolean {
        let result: boolean = false;

        try {
            model.desc = '';
            let temp: string = model.factor.toLowerCase();

            switch (temp) {
                case 'water':
                case 'wtr':
                    model.factor = 'Water';
                    break;
                case 'pastoral':
                case 'pstrl':
                case 'past':
                    model.factor = 'Pastoral';
                    break;
                case 'woods':
                case 'wood':
                case 'wd':
                case 'wds':
                    model.factor = 'Woods';
                    break;
                case 'golf course':
                case 'golf':
                case 'glfvw':
                case 'glf':
                case 'glfcse':
                    model.factor = 'Golf Course';
                    break;
                case 'city/skyline':
                case 'skyline':
                case 'ctysky':
                case 'sky':
                case 'skyln':
                    model.factor = 'City/Skyline';
                    break;
                case 'mountain':
                case 'mtn':
                case 'mnt':
                case 'mount':
                    model.factor = 'Mountain';
                    break;
                case 'residential':
                case 'res':
                    model.factor = 'Residential';
                    break;
                case 'city street':
                case 'street':
                case 'ctystr':
                case 'str':
                    model.factor = 'City Street';
                    break;
                case 'industrial':
                case 'ind':
                    model.factor = 'Industrial';
                    break;
                case 'power lines':
                case 'power':
                case 'pwrln':
                case 'pwr':
                case 'pwr lines':
                    model.factor = 'Power Lines';
                    break;
                case 'limited sight':
                case 'limited':
                case 'ltdsght':
                    model.factor = 'Limited Sight';
                    break;
                case 'prk':
                case 'park':
                case 'pk':
                    model.factor = 'Park';
                    break;
                case 'a':
                    model.factor = 'Adverse';
                    break;
                case 'n':
                    model.factor = 'Neutral';
                    break;
                case 'b':
                    model.factor = 'Beneficial';
                    break;
                default:
                    if (model.factor.length > 0) {
                        model.desc = model.factor;
                        model.factor = 'Other (describe)';
                    }
                    break;
            }
            result = true;
        } catch (error) {
            result = false;
        }

        return result;
    }

    /*
     * Determine if a string contains a valid date.
     */
    private IsValidDate(value: string): boolean {
        let result: boolean = false;

        try {
            value = value?.replace(/\\/gi, '/');
            let dateParts: string[];
            let delimiters: string[] = ['-', '/'];
            let date: number;
            dateParts = value?.split(new RegExp(delimiters.join('|'), 'g'));
            if (dateParts?.length > 1) {
                date = Date.parse(value);
                if (!Number.isNaN(date)) {
                    result = true;
                }
            }
        } catch (error) {
            console.log(`FieldParser.IsValidDate(), Error[${error}]`);
        }

        return result;
    }

    private GetOverallFactor(factor: string): string {
        let result: string = '';

        try {
            switch (factor?.toLowerCase()) {
                case 'n':
                case 'neutral':
                    result = 'Neutral';
                    break;
                case 'a':
                case 'adverse':
                    result = 'Adverse';
                    break;
                case 'b':
                case 'beneficial':
                    result = 'Beneficial';
                    break;
                default:
                    result = '';
                    break;
            }
        } catch (error) {
            result = '';
        }

        return result;
    }

    private ValidateLocationFactor(model: { factor: string; desc: string }): boolean {
        let result: boolean = false;
        try {
            model.desc = '';
            switch (model.factor.toLowerCase()) {
                case 'res':
                case 'residential':
                    model.factor = 'Residential';
                    break;
                case 'ind':
                case 'industrial':
                    model.factor = 'Industrial';
                    break;
                case 'comm':
                case 'commercial':
                case 'com':
                    model.factor = 'Commercial';
                    break;
                case 'bsyrd':
                case 'busy road':
                case 'busy':
                case 'road':
                    model.factor = 'Busy Road';
                    break;
                case 'wtrfr':
                case 'water':
                case 'wtr':
                case 'water front':
                    model.factor = 'Water Front';
                    break;
                case 'glfcse':
                case 'golf':
                case 'glf':
                case 'golf course':
                    model.factor = 'Golf Course';
                    break;
                case 'adjprk':
                case 'prk':
                case 'park':
                case 'adj. to park':
                    model.factor = 'Adj. to Park';
                    break;
                case 'adjpwr':
                case 'pwr':
                case 'power':
                case 'power lines':
                case 'pwr lines':
                    model.factor = 'Adj. to Pwr Lines';
                    break;
                case 'lndfl':
                case 'landfill':
                    model.factor = 'Landfill';
                    break;
                case 'pubtrn':
                case 'public transit':
                case 'transit':
                case 'trn':
                case 'trans':
                case 'tran':
                case 'pub':
                    model.factor = 'Public Transit';
                    break;
                default:
                    if (model.factor.length > 0) {
                        model.desc = model.factor;
                        model.factor = 'Other (describe)';
                    }
                    break;
            }
            result = true;
        } catch (error) {
            result = false;
        }
        return result;
    }

    private IsDigit(char: string): boolean {
        var result = char?.match(/\d+/g);
        return result != null;
    }

    private StringToBool(value: string): boolean {
        let result: boolean = false;

        if (!this.IsEmpty(value)) {
            result = true;
            if (value?.length > 0) {
                result = value.toLowerCase() == 'false';
            }
        }

        return result;
    }

    private IsDigitOnlyContent(value: string): boolean {
        let result: boolean = false;
        const chars = value;

        try {
            if (!this.IsEmpty(value)) {
                result = true;

                for (let i: number = 0; i < chars.length; i++) {
                    const char = chars?.charAt(i);

                    if (!this.IsDigit(char)) {
                        switch (char) {
                            case '+':
                            case '-':
                            case '.':
                            case ',':
                                break;
                            default:
                                result = false;
                                break;
                        }
                    }
                    if (!result) {
                        break;
                    }
                }
            }
        } catch (error) {
            console.log(`FieldParser.IsDigitOnlyContent(), Error[${error}]`);
            result = false;
        }

        return result;
    }

    private GetCommaFormattedString(value: string): string {
        let tmpNum: number = Number.parseFloat(value);
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        // Format as USD currency.
        let tmpVal: string = formatter.format(tmpNum).toString();

        // Remove trailing decimals.
        return tmpVal?.substring(0, tmpVal.indexOf('.'));
    }

    private GetCommaFormattedStringNotCurrency(value: string): string {
        let tmpNum: number = Number.parseFloat(value.replace(/,/g, ''));
        let tmpVal: string = tmpNum.toLocaleString('en-US');

        return tmpVal;
    }

    public AutoCorrectUADValue(fieldName: string) {
        try {
            if (this.parserExecuting) return;

            let tmpVal: string = '';
            let tmpNum: number = 0;
            this.parserExecuting = true;

            switch (fieldName?.toUpperCase()) {
                case 'HS_PRIOR1':
                    this.HS_PRIOR1 = this.ParseDate(this._HS_PRIOR1, this.FieldDateFormats?.get('HS_PRIOR1'));
                    break;

                case 'HS_PRIOR2':
                    tmpVal = String(this._HS_PRIOR2);
                    let tmpNum: number = 0;

                    if (tmpVal?.startsWith('$')) {
                        tmpVal = tmpVal.substring(1);
                    }

                    tmpVal = tmpVal.replace(/,/g, '');

                    if (this.IsDigitOnlyContent(tmpVal)) {
                        tmpVal = this.GetCommaFormattedString(tmpVal);
                    }

                    this.HS_PRIOR2 = tmpVal;
                    break;

                case 'PR_SALEPR1':
                    tmpVal = String(this._PR_SALEPR1);

                    if (tmpVal?.startsWith('$')) {
                        tmpVal = tmpVal.substring(1);
                    }

                    if (this.IsDigitOnlyContent(tmpVal)) {
                        tmpVal = this.GetCommaFormattedStringNotCurrency(tmpVal);
                    }

                    this.PR_SALEPR1 = tmpVal;
                    break;

                case 'SF_GLA':
                    tmpVal = String(this._SF_GLA);

                    if (this.IsDigitOnlyContent(tmpVal)) {
                        tmpVal = this.GetCommaFormattedStringNotCurrency(tmpVal);
                    }

                    this.SF_GLA = tmpVal;
                    break;

                // Site size.
                case 'ST_SITSIZE':
                    tmpVal = this._ST_SITSIZE;
                    let newVal: string = '';
                    let suffix: string = '';
                    let decimal: boolean = false;
                    let format: string = '0,000';
                    let value: string = '';
                    let i: number = 0;
                    let ch: string = '';
                    let dVal: number = 0;

                    for (i = 0; i < tmpVal.length; i++) {
                        ch = tmpVal.charAt(i);

                        if (this.IsDigit(ch)) {
                            newVal += tmpVal.charAt(i);
                        } else if (ch == '.') {
                            newVal += ch;
                            decimal = true;
                            format = '0,000.00';
                        } else if (ch != ',') {
                            break;
                        }
                    }

                    value = newVal;

                    if (i < tmpVal.length - 1) {
                        suffix = tmpVal.substring(i).trim();
                    }

                    if (!this.IsEmpty(value) && this.IsDigitOnlyContent(value)) {
                        dVal = Number.parseFloat(value);
                        if (!this.IsEmpty(suffix)) {
                            ch = suffix.substring(0, 1).toUpperCase();
                            if (ch == 'A') {
                                if (dVal < 1) {
                                    dVal = dVal * 43560;
                                    newVal = dVal.toString() + ' sf';
                                } else {
                                    newVal = value + ' ac';
                                }
                            } else if (ch == 'S') {
                                if (dVal >= 43560) {
                                    dVal /= 43560;
                                    newVal = Number.parseFloat(dVal.toString()).toFixed(1) + ' ac';
                                } else {
                                    newVal = dVal.toString() + ' sf';
                                }
                            }
                        } else {
                            if (decimal == true) {
                                if (dVal < 1) {
                                    dVal = dVal * 43650;
                                    newVal = dVal.toString() + ' sf';

                                    //if (dVal > 999.9) {
                                    //    newVal = newVal + " sf"
                                    //}
                                } else {
                                    newVal = newVal + ' ac';
                                }
                            } else {
                                if (dVal >= 43560) {
                                    dVal /= 43560;
                                    newVal = Number.parseFloat(dVal.toString()).toFixed(1) + ' ac';
                                } else {
                                    newVal = dVal.toString() + ' sf';
                                }
                            }
                        }
                    }
                    this._ST_SITSIZE = newVal;
                    break;

                // Sales or financial concessions
                case 'FN_CONC1':
                    tmpVal = String(this._FN_CONC1)?.toLowerCase();
                    if (tmpVal?.startsWith('reo') || tmpVal == 'rs') {
                        this.FN_CONC1 = 'REO';
                    } else if (tmpVal?.startsWith('es')) {
                        this.FN_CONC1 = 'Estate';
                    } else if (tmpVal?.startsWith('short') || tmpVal == 'ss') {
                        this.FN_CONC1 = 'Short';
                    } else if (tmpVal?.startsWith('court') || tmpVal == 'cos' || tmpVal == 'crt') {
                        this.FN_CONC1 = 'CrtOrd';
                    } else if (tmpVal?.startsWith('relo') || tmpVal == 'rls') {
                        this.FN_CONC1 = 'Relo';
                    } else if (tmpVal?.startsWith('non') || tmpVal == 'nals') {
                        this.FN_CONC1 = 'NonArm';
                    } else if (tmpVal?.startsWith('arm') || tmpVal == 'als') {
                        this.FN_CONC1 = 'ArmLth';
                    }
                    break;

                // Quality of construction
                case 'DA_CONSTQL':
                    tmpVal = this._DA_CONSTQL?.toLowerCase().trim();
                    switch (tmpVal) {
                        case 'q1':
                        case '1':
                            this.DA_CONSTQL = 'Q1';
                            break;
                        case 'q2':
                        case '2':
                            this.DA_CONSTQL = 'Q2';
                            break;
                        case 'q3':
                        case '3':
                            this.DA_CONSTQL = 'Q3';
                            break;
                        case 'q4':
                        case '4':
                            this.DA_CONSTQL = 'Q4';
                            break;
                        case 'q5':
                        case '5':
                            this.DA_CONSTQL = 'Q5';
                            break;
                        case 'q6':
                        case '6':
                            this.DA_CONSTQL = 'Q6';
                            break;
                    }
                    break;

                // Condition
                case 'AG_COND1':
                    tmpVal = this._AG_COND1?.toLowerCase().trim();
                    switch (tmpVal) {
                        case 'c1':
                        case '1':
                            this.AG_COND1 = 'C1';
                            break;
                        case 'c2':
                        case '2':
                            this.AG_COND1 = 'C2';
                            break;
                        case 'c3':
                        case '3':
                            this.AG_COND1 = 'C3';
                            break;
                        case 'c4':
                        case '4':
                            this.AG_COND1 = 'C4';
                            break;
                        case 'c5':
                        case '5':
                            this.AG_COND1 = 'C5';
                            break;
                        case 'c6':
                        case '6':
                            this.AG_COND1 = 'C6';
                            break;
                    }
                    break;

                // Page one DFE - not used.
                case 'DP_OVRLCOND':
                    break;

                default:
                    // Date formatting.
                    break;
            }
        } catch (error) {
            console.log(`FieldParser.AutoCorrectUADValue(), Error[${error}]`);
        }
        this.parserExecuting = false;
    }
}
